import type { ChallengeType } from "@expert/shared-types/src/sales";
import type { JSX } from "react";

import { Warning } from "@/common-ui";

import { GreenCircleCheck } from "../../icons/GreenCircleCheck";
import { RedFrown } from "../../icons/RedFrown";
import { YellowCancel } from "../../icons/YellowCancel";

interface announcementConfig {
    mainText: (winningTeam?: string) => string;
    secondaryText: string;
    icon: JSX.Element;
    winningTeam?: (winningTeam: string) => string;
}

const RedWarning = Warning();

const soloConfigMap: Record<string, announcementConfig> = {
    ["missed"]: {
        mainText: (_winningTeam) => "Challenge has ended",
        secondaryText: "You didn’t quite make it. You’ll get it next time.",
        icon: RedWarning,
    },
    ["exceeded"]: {
        mainText: (_winningTeam) => "Challenge has ended",
        secondaryText: "You had too many cancels. Try again next time.",
        icon: RedWarning,
    },
    ["success"]: {
        mainText: (_winningTeam) => "Success!",
        secondaryText: "Congrats on hitting your goal!",
        icon: GreenCircleCheck,
    },
    ["error"]: {
        mainText: (_winningTeam) => "Something went wrong when evaluating this challenge",
        secondaryText: "Nothing bad happened, but you should let someone know",
        icon: RedFrown,
    },
};

const groupConfigMap: Record<string, announcementConfig> = {
    ["missed"]: {
        mainText: (winningTeam) => `${winningTeam} wins`,
        secondaryText: "Your team didn’t quite make it. Better luck next time.",
        icon: RedFrown,
    },
    //think exceeded time limit in this case
    ["exceeded"]: {
        mainText: (_winningTeam) => "No winner",
        secondaryText: "Both teams missed the target. Better luck next time.",
        icon: YellowCancel,
    },
    ["dropped"]: {
        mainText: (_winningTeam) => "Challenge has ended",
        secondaryText: "Your team had too many cancels.",
        icon: RedWarning,
    },
    ["success"]: {
        mainText: (winningTeam) => `${winningTeam} wins!`,
        secondaryText: "Congrats on hitting your goal!",
        icon: GreenCircleCheck,
    },
    ["error"]: {
        mainText: (_winningTeam) => "something went wrong when evaluating this challenge",
        secondaryText: "nothing bad happened, but you should let someone know",
        icon: RedFrown,
    },
};

export const getAnnouncementEndConfig = ({
    challengeType,
    result,
}: {
    challengeType: ChallengeType;
    result: "missed" | "exceeded" | "dropped" | "success" | "error";
}) => {
    return challengeType === "solo" ? soloConfigMap[result] : groupConfigMap[result];
};
